import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: []
    },
    LastName: {
      validations: []
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
      ]
    },
    clientName: {
      validations: []
    },
    addressline1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
      ]
    },
    StartTime: {
      validations: []
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
      ]
    },   
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:',
            mapping: 'Email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name:',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
                type: 'text',
                size: 'Medium',
                label: 'Street Address',
                mapping: 'addressline1'
              }
            ]
          },
          {
            fields: [
    
              {
                type: 'text',
                size: 'Medium',
                label: 'City:',
                mapping: 'city'
              },
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'State:',
                options: [
                  { label: 'Alabama', value: 'AL' },
                  { label: 'Alaska', value: 'AK' },
                  { label: 'Arizona', value: 'AZ' },
                  { label: 'Arkansas', value: 'AR' },
                  { label: 'American Somoa', value: 'AS' },              
                  { label: 'California', value: 'CA' },
                  { label: 'Colorado', value: 'CO' },
                  { label: 'Connecticut', value: 'CT' },
                  { label: 'Delaware', value: 'DE' },
                  { label: 'District of Columbia', value: 'DC' },
                  { label: 'Florida', value: 'FL' },
                  { label: 'Georgia', value: 'GA' },
                  { label: 'Hawaii', value: 'HI' },
                  { label: 'Idaho', value: 'ID' },
                  { label: 'Illinois', value: 'IL' },
                  { label: 'Indiana', value: 'IN' },
                  { label: 'Iowa', value: 'IA' },
                  { label: 'Kansas', value: 'KS' },
                  { label: 'Kentucky', value: 'KY' },
                  { label: 'Louisiana', value: 'LA' },
                  { label: 'Maine', value: 'ME' },
                  { label: 'Maryland', value: 'MD' },
                  { label: 'Massachusetts', value: 'MA' },
                  { label: 'Michigan', value: 'MI' },
                  { label: 'Minnesota', value: 'MN' },
                  { label: 'Mississippi', value: 'MS' },
                  { label: 'Missouri', value: 'MO' },
                  { label: 'Northern Mariana Islands', value: 'NMI' },
                  { label: 'Montana', value: 'MT' },
                  { label: 'National', value: 'National' },
                  { label: 'Nebraska', value: 'NE' },
                  { label: 'Nevada', value: 'NV' },
                  { label: 'New Hampshire', value: 'NH' },
                  { label: 'New Jersey', value: 'NJ' },
                  { label: 'New Mexico', value: 'NM' },
                  { label: 'New York', value: 'NY' },
                  { label: 'North Carolina', value: 'NC' },
                  { label: 'North Dakota', value: 'ND' },
                  { label: 'Ohio', value: 'OH' },
                  { label: 'Oklahoma', value: 'OK' },
                  { label: 'Oregon', value: 'OR' },
                  { label: 'Pennsylvania', value: 'PA' },
                  { label: 'Puerto Rico', value: 'PR' },
                  { label: 'Rhode Island', value: 'RI' },
                  { label: 'South Carolina', value: 'SC' },
                  { label: 'South Dakota', value: 'SD' },
                  { label: 'Tennessee', value: 'TN' },
                  { label: 'Texas', value: 'TX' },
                  { label: 'Utah', value: 'UT' },
                  { label: 'Vermont', value: 'VT' },
                  { label: 'Virginia', value: 'VA' },
                  { label: 'Virgin Islands', value: 'VI' },
                  { label: 'Washington', value: 'WA' },
                  { label: 'West Virginia', value: 'WV' },
                  { label: 'Wisconsin', value: 'WI' },
                  { label: 'Wyoming', value: 'WY' }
                ],
                mapping: 'state'
              },
              {
                type: 'text',
                size: 'Medium',
                label: 'Zip Code:',
                mapping: 'postal'
              }
            ]
          },
          {
            fields: [
              {
                type: 'date-picker',
                size: 'Medium',
                label: 'Event Date:',
                mapping: 'EventDate'
              }
            ]
          },
          {
            fields: [
              {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Event Start Time:',
                    options: [
                      { label: '6:00 AM', value: '06:00:00' },
                      { label: '6:30 AM', value: '06:30:00' },
                      { label: '7:00 AM', value: '07:00:00' },
                      { label: '7:30 AM', value: '07:30:00' },
                      { label: '8:00 AM', value: '08:00:00' },
                      { label: '8:30 AM', value: '08:30:00' },
                      { label: '9:00 AM', value: '09:00:00' },
                      { label: '9:30 AM', value: '09:30:00' },
                      { label: '10:00 AM', value: '10:00:00' },
                      { label: '10:30 AM', value: '10:30:00' },
                      { label: '11:00 AM', value: '11:00:00' },
                      { label: '11:30 AM', value: '11:30:00' },
                      { label: '12:00 PM', value: '12:00:00' },
                      { label: '12:30 PM', value: '12:30:00' },
                      { label: '1:00 PM', value: '13:00:00' },
                      { label: '1:30 PM', value: '13:30:00' },
                      { label: '2:00 PM', value: '14:00:00' },
                      { label: '2:30 PM', value: '14:30:00' },
                      { label: '3:00 PM', value: '15:00:00' },
                      { label: '3:30 PM', value: '15:30:00' },
                      { label: '4:00 PM', value: '16:00:00' },
                      { label: '4:30 PM', value: '16:30:00' },
                      { label: '5:00 PM', value: '17:00:00' },
                      { label: '5:30 PM', value: '17:30:00' },
                      { label: '6:00 PM', value: '18:00:00' },
                      { label: '6:30 PM', value: '18:30:00' },
                      { label: '7:00 PM', value: '19:00:00' },
                      { label: '7:30 PM', value: '19:30:00' },
                      { label: '8:00 PM', value: '20:00:00' },
                      { label: '8:30 PM', value: '20:30:00' },
                      { label: '9:00 PM', value: '21:00:00' },
                      { label: '9:30 PM', value: '21:30:00' },
                      { label: '10:00 PM', value: '22:00:00' },
                      { label: '10:30 PM', value: '22:30:00' },
                      { label: '11:00 PM', value: '23:00:00' },
                      { label: '11:30 PM', value: '23:30:00' },
                      { label: '12:00 AM', value: '00:00:00' },
                      { label: '12:30 AM', value: '00:30:00' },
                      { label: '1:00 AM', value: '01:00:00' },
                      { label: '1:30 AM', value: '01:30:00' },
                      { label: '2:00 AM', value: '02:00:00' },
                      { label: '2:30 AM', value: '02:30:00' },
                      { label: '3:00 AM', value: '03:00:00' },
                      { label: '3:30 AM', value: '03:30:00' },
                      { label: '4:00 AM', value: '04:00:00' },
                      { label: '4:30 AM', value: '04:30:00' },
                      { label: '5:00 AM', value: '05:00:00' },
                      { label: '5:30 AM', value: '05:30:00' }
                    ],
                    mapping: 'StartTime'
                  }
                ]
              },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Tompkins Square Bagels Catering Contact Form',
    formId: '1878',
    clientKey: '62301970-89C1-451E-8B0D-F7D2DCEBE398',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
